'use strict';

module.exports = function () {
    /**
     * Handle appointment edit button click
     */
    $('body').on('click', '.edit-appointment', function (e) {
        e.preventDefault();
        var $button = $(this);
        var appointmentId = $button.data('appointment-id');
        var appointmentName = $button.data('appointment-name');
        var appointmentDate = $button.data('appointment-date');
        var appointmentStart = $button.data('appointment-start');
        var appointmentEnd = $button.data('appointment-end');
        var location = $button.data('location');
        var customerPhone = $button.data('customer-phone');
        var customerEmail = $button.data('customer-email');

        $('#editAppointmentModal').find('input[name="appointmentId"]').val(appointmentId);
        $('#editAppointmentModal').find('.appointment-name-label').text(appointmentName);
        $('#editAppointmentModal').find('input[name="appointmentDate"]').val(appointmentDate);
        $('#editAppointmentModal').find('input[name="timeSlot"]').val(appointmentStart + ' - ' + appointmentEnd);
        $('#editAppointmentModal').find('.showroom-location-label').text(location);
        $('#editAppointmentModal').find('input[name="location"]').val(location);
        $('#editAppointmentModal').find('input[name="showroomName"]').val(location);
        $('#editAppointmentModal').find('input[name="customerPhone"]').val(customerPhone);
        $('#editAppointmentModal').find('input[name="customerEmail"]').val(customerEmail);

        var $appointmentDateInput = $('.appointment-date');
        if ($appointmentDateInput && $appointmentDateInput.length) {
            $.fn.datepicker.dates.en.daysMin = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];
            $appointmentDateInput
                .datepicker('destroy')
                .datepicker({
                    format: 'dd/mm/yyyy',
                    language: 'en',
                    autoclose: true,
                    todayHighlight: false,
                    startDate: '+0d',
                    weekStart: 1,
                    maxViewMode: 2
                })
                .datepicker('setDate', new Date())
                .on('show', function () {
                    e.stopPropagation();
                });

            $appointmentDateInput.on('click', function () {
                $('.table-condensed .prev').text('');
                $('.table-condensed .next').text('');
            });
        }

        $('#editAppointmentModal').modal('show');
    });

    /**
     * Handle edit appointment form submission
     */
    $('body').on('submit', '.edit-appointment-form', function (e) {
        e.preventDefault();
        var $form = $(this);

        var appointmentId = $form.find('input[name="appointmentId"]').val();
        var appointmentDate = $form.find('input[name="appointmentDate"]').val();
        var selectedSlot = $form.find('input[name="selectedSlot"]').val();
        var location = $form.find('input[name="location"]').val();

        $.spinner().start();
        $.ajax({
            url: $form.attr('action'),
            type: 'POST',
            dataType: 'json',
            data: {
                appointmentId: appointmentId,
                newAppointmentDate: appointmentDate,
                newSlot: selectedSlot,
                location: location
            },
            success: function (response) {
                $.spinner().stop();
                if (response.success) {
                    $('#editAppointmentModal').modal('hide');
                    window.location.reload();
                }
            },
            error: function () {
                $.spinner().stop();
            }
        });
    });

    /**
     * Handle go back button
     */
    $('body').on('click', '.go-back', function (e) {
        e.preventDefault();
        $('#editAppointmentModal').modal('hide');
    });

    /**
     * Handle time slot dropdown click in edit appointment modal
     */
    $('body').on('click', '#editAppointmentModal #tryAtShowRoomTimeDropdown', function () {
        var $this = $(this);

        if (!$this.hasClass('opened')) {
            var showroomName = $('#editAppointmentModal input[name="showroomName"]').val();
            var selectedDate = $('#editAppointmentModal input[name="appointmentDate"]').val();
            var customerPhone = $('#editAppointmentModal input[name="customerPhone"]').val();
            var customerEmail = $('#editAppointmentModal input[name="customerEmail"]').val();
            var url = $this.data('url');

            $.ajax({
                url: url,
                method: 'POST',
                data: {
                    storeID: showroomName,
                    selectedDate: selectedDate,
                    customerPhone: customerPhone,
                    customerEmail: customerEmail
                },
                success: function (data) {
                    $('#editAppointmentModal #tryAtSlot').html(data);
                },
                error: function () {
                    $('#editAppointmentModal #tryAtSlot').html('<li class="custom-option-value disabled">No slots available</li>');
                }
            });
        }
    });

    /**
     * Handle time slot selection in edit appointment modal
     */
    $('body').on('click', '#editAppointmentModal .time-slot-value', function () {
        if ($(this).hasClass('strick-out')) return;

        var selectedSlot = $(this).data('id');
        $('#editAppointmentModal input[name="selectedSlot"]').val(selectedSlot);
        $('#editAppointmentModal .tas-selected-value').text(selectedSlot);
        $('#editAppointmentModal .tas-selected-value').attr('data-slot', selectedSlot);
    });

    /**
     * Handle date change to reset time slot
     */
    $('body').on('change', '#editAppointmentModal input[name="appointmentDate"]', function () {
        if ($(this).val().trim()) {
            var $tasSelectedValue = $('#editAppointmentModal .tas-selected-value');
            var altText = $tasSelectedValue.attr('data-alttext') || $tasSelectedValue.data('alttext');
            $tasSelectedValue.text(altText || '');
            $tasSelectedValue.attr('data-slot', '');
            $('#editAppointmentModal input[name="selectedSlot"]').val('');
        }
    });

    /**
     * Handle location change to reset time slot
     */
    $('body').on('change', '#editAppointmentModal input[name="location"]', function () {
        var $tasSelectedValue = $('#editAppointmentModal .tas-selected-value');
        var altText = $tasSelectedValue.attr('data-alttext') || $tasSelectedValue.data('alttext');
        $tasSelectedValue.text(altText || '');
        $tasSelectedValue.attr('data-slot', '');
        $('#editAppointmentModal input[name="selectedSlot"]').val('');
    });

    /**
     * Handle appointment cancel button click
     */
    $('body').on('click', '.cancel-appointment', function (e) {
        e.preventDefault();
        var $this = $(this);
        var appointmentId = $(this).data('appointment-id');
        $.spinner().start();
        $.ajax({
            url: $('.appointments-wrapper').data('cancel-url'),
            type: 'POST',
            dataType: 'json',
            data: {
                appointmentId: appointmentId
            },
            success: function (response) {
                $.spinner().stop();
                if (response.success) {
                    $this.siblings('.service-response-message').text(response.message);
                } else {
                    $this.siblings('.service-response-message').text(response.message);
                }
            },
            error: function () {
                $.spinner().stop();
            }
        });
    });
};
